import { Tooltip as MuiToolTip} from '@mui/material' ;

interface IDefaultToolTipProps {
  title: string | JSX.Element;
  children: React.ReactElement;
}

export function Tooltip({
  title,
  children
}: IDefaultToolTipProps) {
  
    return (
    <MuiToolTip title={title || '...'} >
        {children}
    </MuiToolTip>
  )
 
}
 